import React from 'react';

export const RecordsTable = ({ records, isLoading, formatDateTime }) => {
    const skeletonRows = Array.from({ length: 8 }, (_, index) => index);

    return (
        <div className="table-responsive border rounded-3">
            <table className="table table-hover align-middle mb-0">
                <thead>
                    <tr>
                        <th className="text-uppercase fs-11 fw-semibold py-3">Fecha</th>
                        <th className="text-uppercase fs-11 fw-semibold py-3">Método</th>
                        <th className="text-uppercase fs-11 fw-semibold py-3">Función</th>
                        <th className="text-uppercase fs-11 fw-semibold py-3">Mensaje</th>
                        <th className="text-uppercase fs-11 fw-semibold py-3">Usuario</th>
                    </tr>
                </thead>
                <tbody>
                    {isLoading && (
                        <>
                            {skeletonRows.map((row) => (
                                <tr key={`record-skeleton-${row}`}>
                                    <td className="py-2"><div className="table-skeleton table-skeleton--date"></div></td>
                                    <td className="py-2"><div className="table-skeleton table-skeleton--name"></div></td>
                                    <td className="py-2"><div className="table-skeleton table-skeleton--contact"></div></td>
                                    <td className="py-2"><div className="table-skeleton table-skeleton--email"></div></td>
                                    <td className="py-2"><div className="table-skeleton table-skeleton--contact"></div></td>
                                </tr>
                            ))}
                        </>
                    )}

                    {!isLoading && records.map((record) => (
                        <tr key={record._id}>
                            <td className="py-0">{formatDateTime(record.createdDate)}</td>
                            <td className="py-0">{record.method || '-'}</td>
                            <td className="py-0">{record.functionName || '-'}</td>
                            <td className="py-0">{record.message || '-'}</td>
                            <td className="py-0">{record.userDisplay || '-'}</td>
                        </tr>
                    ))}

                    {!isLoading && records.length === 0 && (
                        <tr>
                            <td colSpan={5} className="text-center text-muted py-4">
                                No se encontraron records con ese criterio de búsqueda.
                            </td>
                        </tr>
                    )}
                </tbody>
            </table>
        </div>
    );
};
